import type { ErrorComponentProps } from '@tanstack/react-router'
import { RotateCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

/** Shown when a screen fails to render or load. Says what happened and what to do. */
export function ErrorScreen({ error, reset }: ErrorComponentProps) {
  const offline = typeof navigator !== 'undefined' && !navigator.onLine
  return (
    <main className="grid min-h-dvh place-items-center bg-background p-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold">
          {offline ? 'You are offline' : 'This screen could not be shown'}
        </h1>
        <p className="mt-2 text-[15px] text-muted-foreground">
          {offline
            ? 'Reconnect to the internet, then try again. Nothing you saved has been lost.'
            : 'Try again. If it keeps happening, tell Richard what you were doing and quote the message below.'}
        </p>
        {!offline && (
          <p className="mt-4 rounded-md border bg-muted px-3 py-2 text-left font-mono text-xs break-words text-muted-foreground">
            {error instanceof Error ? error.message : String(error)}
          </p>
        )}
        <Button
          className="mt-6 h-11 px-5"
          onClick={() => {
            reset()
            window.location.reload()
          }}
        >
          <RotateCw />
          Try again
        </Button>
      </div>
    </main>
  )
}
